import { render, staticRenderFns } from "./vendor-list.vue?vue&type=template&id=3da34090&scoped=true&"
import script from "./vendor-list.vue?vue&type=script&lang=js&"
export * from "./vendor-list.vue?vue&type=script&lang=js&"
import style0 from "./vendor-list.vue?vue&type=style&index=0&id=3da34090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da34090",
  null
  
)

export default component.exports